import React, { useCallback, useMemo } from "react";
import type { FMR1Fields } from "../../../../../api/fmr1";
import { useAppDispatch, useAppSelector } from "../../../../../app/store";
import { selectFMR1DraftFmrFields, updateFMR1DraftField } from "../../../logic/frm1Slice";
import { FmrSingleRowGridTable } from "../common/FmrSingleRowGridTable";
import { YES_NO_OPTIONS } from "../common/utils";

type FMR1Data = FMR1Fields;

const PARTICULARS_COL_WIDTH = "253px";
const SCBMF_Q1_COL_WIDTH = "400px";
const SCBMF_DIRECTIONS_COL_WIDTH = "160px";
const SCBMF_COMPLIANCE_COL_WIDTH = "281px";

const ScbmfComplianceTable: React.FC = () => {
  const dispatch = useAppDispatch();

  const draftFields = useAppSelector(selectFMR1DraftFmrFields);

  const emptyData = useMemo(() => ({}) as FMR1Data, []);
  const mergedData = useMemo(() => {
    return { ...emptyData, ...(draftFields as any) } as FMR1Data;
  }, [draftFields, emptyData]);

  const handleLocalChange = useCallback(
    (key: keyof FMR1Fields, value: any) => {
      dispatch(updateFMR1DraftField({ key, value }));
    },
    [dispatch],
  );

  const scbfReported = mergedData.scbf_reported ?? "";

  return (
    <FmrSingleRowGridTable
      title="Details on SCBMF Compliance"
      particularsColWidth={PARTICULARS_COL_WIDTH}
      columns={[
        {
          headerName:
            "Whether the fraud has been reported to Special Committee of Board for monitoring and follow up of cases of Frauds (SCBMF)",
          type: "select",
          options: YES_NO_OPTIONS,
          value: scbfReported,
          onChange: (v) => handleLocalChange("scbf_reported", v),
          isEditable: true,
          colWidth: SCBMF_Q1_COL_WIDTH,
        },
        {
          headerName: "If yes, Directions given by the SCBMF (in brief)",
          type: "text",
          value: mergedData.scbf_directions ?? "",
          onChange: (v) => handleLocalChange("scbf_directions", v),
          isEditable: true,
          colWidth: SCBMF_DIRECTIONS_COL_WIDTH,
        },
        {
          headerName: "Compliance given by the bank to the directions given to SCBMF",
          type: "text",
          value: mergedData.scbf_compliance_given_by_bank ?? "",
          onChange: (v) => handleLocalChange("scbf_compliance_given_by_bank", v),
          isEditable: true,
          colWidth: SCBMF_COMPLIANCE_COL_WIDTH,
        },
      ]}
    />
  );
};

ScbmfComplianceTable.displayName = "ScbmfComplianceTable";

export default ScbmfComplianceTable;

